import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLiveQuery } from "dexie-react-hooks";
import { recomendacionesParaCarrito, type ProductoCopiloto } from "@huayruro/shared";
import { dbLocal } from "./db-local";

// Copiloto del mostrador, etapa 1 (Kevin, 16-oct-2026). Lee lo que el sync dejó en Dexie (funciona sin
// red) y arma las recomendaciones para el carrito. Las marcas de «ya pregunté» son solo de esta venta:
// se limpian cuando el carrito pasa de tener algo a quedar vacío (se cobró o se vació). No se guardan.
export function useCopiloto(productos: ProductoCopiloto[]) {
  const preguntas = useLiveQuery(async () => (await dbLocal.copiloto_preguntas.toArray()).sort((a, b) => a.orden - b.orden || a.id.localeCompare(b.id)), []);
  const recs = useLiveQuery(() => dbLocal.copiloto_recomendaciones.toArray(), []);
  const [marcadas, setMarcadas] = useState<Set<string>>(() => new Set());

  const habia = useRef(productos.length);
  useEffect(() => {
    if (habia.current > 0 && productos.length === 0) setMarcadas(new Set());
    habia.current = productos.length;
  }, [productos.length]);

  const onMarcar = useCallback((id: string) => {
    setMarcadas((prev) => {
      const s = new Set(prev);
      if (s.has(id)) s.delete(id);
      else s.add(id);
      return s;
    });
  }, []);

  const recomendaciones = useMemo(() => recomendacionesParaCarrito(recs ?? [], productos), [recs, productos]);
  return { preguntas: preguntas ?? [], recomendaciones, marcadas, onMarcar };
}
